import { render, staticRenderFns } from "./downloadButton.vue?vue&type=template&id=44becd5f&scoped=true"
import script from "./downloadButton.vue?vue&type=script&lang=js"
export * from "./downloadButton.vue?vue&type=script&lang=js"
import style0 from "./downloadButton.vue?vue&type=style&index=0&id=44becd5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44becd5f",
  null
  
)

export default component.exports